import { EFundsOperation } from '@enum';
import { ETransactionAction, ETransactionMethod, ETransactionType } from '@xeppt/xeppt-sdk/types';

export const paymentsConfig = {
    [EFundsOperation.WALLET_CREDIT_TRANSFER]: {
        method: ETransactionMethod.WALLET,
        type: ETransactionType.CREDIT,
        action: ETransactionAction.TRANSFER
    },
    [EFundsOperation.WALLET_DEBIT_TRANSFER]: {
        method: ETransactionMethod.WALLET,
        type: ETransactionType.DEBIT,
        action: ETransactionAction.TRANSFER
    },
    [EFundsOperation.WALLET_CREDIT_REQUEST]: {
        method: ETransactionMethod.WALLET,
        type: ETransactionType.CREDIT,
        action: ETransactionAction.REQUEST
    },
    [EFundsOperation.WALLET_DEBIT_REQUEST]: {
        method: ETransactionMethod.WALLET,
        type: ETransactionType.DEBIT,
        action: ETransactionAction.REQUEST
    },
    [EFundsOperation.WALLET_CREDIT_CARD_DEPOSIT]: {
        method: ETransactionMethod.WALLET,
        type: ETransactionType.CREDIT,
        action: ETransactionAction.CARD_DEPOSIT
    },
    [EFundsOperation.WALLET_CREDIT_CARD_SERVICE]: {
        method: ETransactionMethod.WALLET,
        type: ETransactionType.CREDIT,
        action: ETransactionAction.CARD_SERVICE
    },
    [EFundsOperation.WALLET_CREDIT_PAYMENT]: {
        method: ETransactionMethod.WALLET,
        type: ETransactionType.CREDIT,
        action: ETransactionAction.PAYMENT
    },
    [EFundsOperation.WALLET_DEBIT_PAYMENT]: {
        method: ETransactionMethod.WALLET,
        type: ETransactionType.DEBIT,
        action: ETransactionAction.PAYMENT
    },
    [EFundsOperation.PAY_BILL_CREDIT_PAYMENT]: {
        method: ETransactionMethod.PAY_BILL,
        type: ETransactionType.CREDIT,
        action: ETransactionAction.PAYMENT
    },
    [EFundsOperation.E_TRANSFER_CREDIT_TRANSFER]: {
        method: ETransactionMethod.E_TRANSFER,
        type: ETransactionType.CREDIT,
        action: ETransactionAction.TRANSFER
    },
    [EFundsOperation.E_TRANSFER_DEBIT_TRANSFER]: {
        method: ETransactionMethod.E_TRANSFER,
        type: ETransactionType.DEBIT,
        action: ETransactionAction.TRANSFER
    },
    [EFundsOperation.E_TRANSFER_DEBIT_REQUEST]: {
        method: ETransactionMethod.E_TRANSFER,
        type: ETransactionType.DEBIT,
        action: ETransactionAction.REQUEST
    },
    [EFundsOperation.EFT_CREDIT_WITHDRAWAL]: {
        method: ETransactionMethod.EFT,
        type: ETransactionType.CREDIT,
        action: ETransactionAction.WITHDRAW
    },
    [EFundsOperation.EFT_DEBIT_DEPOSIT]: {
        method: ETransactionMethod.EFT,
        type: ETransactionType.DEBIT,
        action: ETransactionAction.DEPOSIT
    },
    [EFundsOperation.EPS_DEBIT_DEPOSIT]: {
        method: ETransactionMethod.EPS,
        type: ETransactionType.DEBIT,
        action: ETransactionAction.DEPOSIT
    },
    [EFundsOperation.CARD_CREDIT_WITHDRAWAL]: {
        method: ETransactionMethod.CARD,
        type: ETransactionType.CREDIT,
        action: ETransactionAction.CARD_TANSACTION
    },
    [EFundsOperation.CARD_DEBIT_DEPOSIT]: {
        method: ETransactionMethod.CARD,
        type: ETransactionType.DEBIT,
        action: ETransactionAction.CARD_DEPOSIT
    },
    [EFundsOperation.GIFT_CARD_CREDIT_GIFT_CARD]: {
        method: ETransactionMethod.GIFT_CARD,
        type: ETransactionType.CREDIT,
        action: ETransactionAction.GIFT_CARD
    },
    [EFundsOperation.GIFT_CARD_DEBIT_GIFT_CARD_REDEEM]: {
        method: ETransactionMethod.GIFT_CARD,
        type: ETransactionType.DEBIT,
        action: ETransactionAction.GIFT_CARD_REDEEM
    },
    [EFundsOperation.GIFT_CARD_CREDIT_RESERVE]: {
        method: ETransactionMethod.GIFT_CARD,
        type: ETransactionType.CREDIT,
        action: ETransactionAction.GIFT_CARD_RESERVE
    },
    [EFundsOperation.GIFT_CARD_DEBIT_RESERVE]: {
        method: ETransactionMethod.GIFT_CARD,
        type: ETransactionType.DEBIT,
        action: ETransactionAction.GIFT_CARD_RESERVE
    },
};
